import React, { useEffect, useState } from 'react';
import { IAutocompleteField, IContact, IField, ITextField } from '../../shared/interfaces';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { IBasePicker, IBasePickerSuggestionsProps, ITag, Label, mergeStyleSets, TagPicker, IMessageBarProps, MessageBarType, ScrollablePane, Persona, PersonaSize, FontIcon, IPersonaProps } from '@fluentui/react';
import { reduxActions, RootState } from '../../store';
import { useSelector } from 'react-redux';
import DynamicForm from '../DynamicForm/DynamicForm';

import { store } from '../..';
import { useBoolean } from '@fluentui/react-hooks';
import ReadonlyField from '../DynamicForm/ReadonlyField';



const classNames = mergeStyleSets({
    scrollablePaneWrapper: {
        position: 'relative',
        height: '100%',
    },

    inputWrapper:
    {
        paddingBottom: '20px',

    },
    compactCard: {
        alignItems: 'center',
        padding: "0 20px"
    },
    expandedCard: {
        padding: '16px 24px'
    },
    iconClass: {
        fontSize: 20,
        margin: '0 25px'
    },
    contactInfoGroup: {
        padding: '4px 0px',
    },

    address: {
        height: '20px'
    }

});




export interface RubricaFormProps {
    extraCssClass?: string
    onError: (errorMessageProps: IMessageBarProps) => void
}




const RubricaForm: React.FunctionComponent<RubricaFormProps> = (props) => {


    let [loading, { setTrue: showLoader, setFalse: hideLoader }] = useBoolean(false);

    let [rubricaFormFields, setRubricaFormFields] = useState<IField[]>([
        {
            displayName: "Ricerca un contatto della rubrica",
            internalName: "rubrica",
            list: "Rubrica",
            sharepointType: "",
            controlType: "autocompleteContact",
            required: false,
            readonly: false,
            disabled: false,
            system: false,
            internalValue: [],
            valid: false,
            touched: false,
            multi: false,
        } as IAutocompleteField
    ]);


    let [contactCard, setContactCard] = useState<IContact | undefined>(undefined);
    let [persProps, setPersProps] = useState<IPersonaProps | undefined>(undefined);

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);


    const onInputChangedHandler = (updatedField: IField) => {
        const updatedRubricaFields = [...(rubricaFormFields ?? [])];
        let itemIndex = updatedRubricaFields.findIndex(el => el.internalName === updatedField.internalName);/// l'inertnalName è sempre rubrica
        updatedRubricaFields[itemIndex] = { ...updatedField };

        setRubricaFormFields([...updatedRubricaFields]);
        if (updatedField.internalValue && updatedField.internalValue.length === 1) {
            let internalValue = updatedField.internalValue[0];
            let { contact, ...persProps } = internalValue;
            setContactCard(contact);
            setPersProps(persProps);
        } else {
            setContactCard(undefined);
            setPersProps(undefined);
        }
    }

    const renderContactInfo = (): JSX.Element => {


        // (!!) per forzare esplicitamente i valori a booleano e non string
        let showAddress: boolean = !!contactCard && (!!contactCard?.stato || !!contactCard?.provincia || !!contactCard?.localita || !!contactCard?.indirizzo || !!contactCard?.cap);
        let provincia: string = !!contactCard?.provincia && contactCard?.provincia !== contactCard?.localita ? contactCard?.provincia : "";
        let localitaInfo: any[] = [contactCard?.localita, provincia, contactCard?.cap];
        let localita: string = localitaInfo.filter(el => el).join(" - "); //prende le informazioni sulla località da contactCard, le filtra per rimuovere eventuali valori nulli o undefined e quindi le unisce in una singola stringa separata da " - ".
        return (
            <React.Fragment>
                <div className={classNames.compactCard}>
                    <Persona
                        {...persProps}
                        size={PersonaSize.size56}
                        hidePersonaDetails={false}
                    />
                </div>
                <div className={classNames.expandedCard}>

                    {contactCard?.email1 &&
                        <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                            <FontIcon aria-label="Mail" iconName="Mail" className={classNames.iconClass} />
                            <ReadonlyField fieldInternalName="email1" content={contactCard.email1} showCopyButton={true}></ReadonlyField>
                        </div>}

                    {contactCard?.email2 &&
                        <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                            <FontIcon aria-label="Mail" iconName="Mail" className={classNames.iconClass} />
                            <ReadonlyField fieldInternalName="email2" content={contactCard.email2} showCopyButton={true}></ReadonlyField>
                        </div>}

                    {contactCard?.telefono1 &&
                        <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                            <FontIcon aria-label="Phone" iconName="Phone" className={classNames.iconClass} />
                            <ReadonlyField fieldInternalName="telefono1" content={contactCard.telefono1} showCopyButton={true}></ReadonlyField>
                        </div>}

                    {contactCard?.telefono2 &&
                        <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                            <FontIcon aria-label="Phone" iconName="Phone" className={classNames.iconClass} />
                            <ReadonlyField fieldInternalName="telefono2" content={contactCard.telefono2} showCopyButton={true}></ReadonlyField>
                        </div>}

                    {showAddress &&
                        <div className={`flex flex-row align-items-start ${classNames.contactInfoGroup}`}>
                            <FontIcon aria-label="POI" iconName="POI" className={classNames.iconClass} style={{ paddingTop: "5px" }} />
                            <div className="flex flex-column align-items-start">
                                <ReadonlyField fieldInternalName="indirizzo" content={contactCard!.indirizzo} showCopyButton={true} className={classNames.address}></ReadonlyField>
                                <ReadonlyField fieldInternalName="localita" content={localita} showCopyButton={true} className={classNames.address}></ReadonlyField>
                                <ReadonlyField fieldInternalName="stato" content={contactCard!.stato} showCopyButton={true} className={classNames.address}></ReadonlyField>
                            </div>
                        </div>}
                </div>
            </React.Fragment>

        );
    }

    return (
        <React.Fragment>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <div className={"flex flex-column position-relative overflow-hidden"}>

                <div className={`position-relative my-scroll-div`}>
                    <DynamicForm
                        fields={rubricaFormFields}
                        onInputChangedHandler={(updatedField) => { onInputChangedHandler(updatedField) }}
                    />

                    {contactCard && persProps &&
                        renderContactInfo()
                    }
                </div>

            </div>

        </React.Fragment>
    );
}

export default RubricaForm;



